export type DentalVoiceCursor = {
  tooth: number
}

export type DentalKeywordState = {
  cursor: DentalVoiceCursor
  paused: boolean
}

export const createDentalKeywordState = (
  cursor: DentalVoiceCursor = { tooth: 1 },
): DentalKeywordState => ({
  cursor: { ...cursor },
  paused: false,
})
